import { Redirect } from 'expo-router'

/**
 * In-tabs ToS link → redirects to the public /legal/terms-of-service
 * route which renders the full counsel-reviewed document from
 * @tago/legal. Keeps the Profile menu link working without owning a
 * second copy of the content.
 */
export default function ProfileTermsRedirect() {
  return <Redirect href={'/legal/terms-of-service' as never} />
}
